<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <b-link class="brand-logo">
        <h2 class="brand-text text-primary ml-1">xVisor</h2>
      </b-link>
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img fluid src="@/assets/images/pages/register-v2.svg" alt="Register V2"/>
        </div>
      </b-col>
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto" @keydown.enter="submitSignup">
          <b-card-title title-tag="h2" class="font-weight-bold mb-1">Complete Signup 🚀</b-card-title>
          <p class="mb-1">Fill out the form below to complete signup.</p>
          <validation-observer ref="signupForm" v-slot="{ invalid }">
            <b-form-group label="Name *" label-for="name">
              <validation-provider #default="{ errors }" name="Name" rules="required">
                <b-form-input
                  id="name"
                  v-model="name"
                  :state="errors.length > 0 ? false : null"
                  name="register-username"
                  placeholder="Name"
                  :autofocus="true"
                />
                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
            <b-form-group label="Password *" label-for="password">
              <validation-provider #default="{ errors }" name="Password" rules="required|validPassword">
                <b-input-group class="input-group-merge" :class="errors.length > 0 ? 'is-invalid' : null">
                  <b-form-input
                    id="password"
                    v-model="password"
                    :type="newPasswordFieldType"
                    :state="errors.length > 0 ? false : null"
                    class="form-control-merge"
                    name="register-password"
                  />
                  <b-input-group-append is-text>
                    <b-icon :icon="newPasswordToggleIcon" class="cursor-pointer" @click="toggleNewPasswordVisibility" />
                  </b-input-group-append>
                </b-input-group>
                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
            <b-form-group label="Confirm Password *" label-for="password">
              <validation-provider #default="{ errors }" name="Confirm Password" rules="required|confirmed:Password">
                <b-input-group class="input-group-merge" :class="errors.length > 0 ? 'is-invalid' : null">
                  <b-form-input
                    id="password"
                    v-model="confirmPassword"
                    :type="confirmPasswordFieldType"
                    :state="errors.length > 0 ? false : null"
                    class="form-control-merge"
                    name="register-password"
                  />
                  <b-input-group-append is-text>
                    <b-icon
                      :icon="confirmPasswordToggleIcon"
                      class="cursor-pointer"
                      @click="toggleConfirmPasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
            <b-button variant="primary" block type="submit" @click.prevent="submitSignup" :disabled="invalid">
              Submit
            </b-button>
          </validation-observer>
        </b-col>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { togglePasswordVisibility } from '@core/mixins/ui/forms';
import generateHash from '@/xvisor/utilities/generateHash';

export default {
  mixins: [togglePasswordVisibility],
  data() {
    return {
      name: '',
      password: '',
      confirmPassword: '',
      newPasswordFieldType: 'password',
      confirmPasswordFieldType: 'password',
    };
  },
  computed: {
    newPasswordToggleIcon() {
      return this.newPasswordFieldType === 'password' ? 'eye' : 'eye-slash';
    },
    confirmPasswordToggleIcon() {
      return this.confirmPasswordFieldType === 'password' ? 'eye' : 'eye-slash';
    },
  },
  methods: {
    toggleNewPasswordVisibility() {
      this.newPasswordFieldType = this.newPasswordFieldType === 'password' ? 'text' : 'password';
    },
    toggleConfirmPasswordVisibility() {
      this.confirmPasswordFieldType = this.confirmPasswordFieldType === 'password' ? 'text' : 'password';
    },
    submitSignup() {
      this.$refs.signupForm.validate().then((result) => {
        if (result) {
          this.$http
            .post(`/finishsignup/${this.$route.params.inviteId}`, {
              name: this.name,
              passwd: generateHash(this.password),
              passwdConfirm: generateHash(this.confirmPassword),
            })
            .then(() => {
              this.$bvToast.toast('Successfully signed up! Redirecting...', { variant: 'success' });
              setTimeout(() => { window.location.replace('/login'); }, 5000);
            })
            .catch(() => {
              this.$bvToast.toast('Failed to complete signup', { variant: 'danger' });
            });
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
